import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { logCrmReminderClientEvent } from "../../utils/crmReminderAnalyticsClient";

const firebaseConfig = {
   apiKey: "AIzaSyB-dQ4hnidZll2kXMozkJ65eOiCUP6ND34",
  authDomain: "ecoomerce-perfume.firebaseapp.com",
  projectId: "ecoomerce-perfume",
  storageBucket: "finance-96d92.appspot.com",
  messagingSenderId: "702219574504",
  appId: "1:702219574504:web:868b14e791142e05ec7d5d"
};

const vapidKey = "BAr0M8CQ_WBLt-gE0FF3lDiTfraht56G-IIJd_b_tPtGMy_q80zHOgNXEqd4QuX3ApVp9RGXFXYJF3rvpQ9qq0U";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted.");
      return null;
    }

    const swRegistration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swRegistration,
    });

    return token;
  } catch (err) {
    console.error("❌ Error getting FCM token:", err);
    return null;
  }
};

export const listenToForegroundMessages = () => {
  onMessage(messaging, (payload) => {
    const data = payload?.data || {};
    const type = data.type || "";
    const taskId = data.taskId || "";
    const leadId = data.leadId || "";
    const phase = data.phase || "primary";
    const isTaskReminder = type === "task_reminder";
    const isDigest =
      type === "crm_reminder_digest" || data.phase === "digest";
    const title = payload?.notification?.title || data.title || "Beentara";
    const body = payload?.notification?.body || data.body || "";
    const url = isTaskReminder
      ? (data.url || `/tasks?taskId=${taskId}`)
      : isDigest
        ? "/crm"
        : leadId
          ? `/crm?leadId=${leadId}`
          : (data.url || "/crm");

    if (isTaskReminder && taskId) {
      /* task reminder delivered via FCM */
    } else if (!isDigest && leadId) {
      logCrmReminderClientEvent({
        leadId,
        eventType: "delivered",
        channel: "push",
        phase,
      });
    } else if (isDigest) {
      logCrmReminderClientEvent({
        eventType: "digest",
        channel: "push",
        phase: "digest",
      });
    }

    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      const options = {
        body,
        icon: "/logo192.png",
        data: { url, leadId, taskId, type },
      };
      navigator.serviceWorker?.ready
        .then((reg) => reg.showNotification(title, options))
        .catch(() => new Notification(title, options));
      return;
    }

    if (payload?.notification) {
      alert(`${title}: ${body}`);
    }
  });
};

export function readNativeFcmToken() {
  const native =
    typeof window !== "undefined" ? window.BeentaraAndroid?.getNativeFcmToken?.() : "";
  return native && String(native).length >= 32 ? String(native) : "";
}

export async function waitForNativeFcmToken({ attempts = 8, delayMs = 750 } = {}) {
  for (let i = 0; i < attempts; i += 1) {
    const token = readNativeFcmToken();
    if (token) return token;
    if (typeof window === "undefined" || !window.BeentaraAndroid?.getNativeFcmToken) {
      return "";
    }
    await new Promise((resolve) => setTimeout(resolve, delayMs));
  }
  return readNativeFcmToken();
}

export async function registerFcmDeviceToken({
  apiUrl,
  userId,
  deviceToken,
  platform,
  authToken,
}) {
  if (!apiUrl || !userId || !deviceToken) return;
  const res = await fetch(`${apiUrl}/firebase/register-token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    },
    body: JSON.stringify({
      user_id: String(userId),
      deviceToken,
      platform: platform || "web",
    }),
  });
  if (!res.ok) {
    throw new Error(`FCM register failed (${res.status})`);
  }
}

export async function unregisterCurrentFcmTokens({ apiUrl, userId, authToken }) {
  if (!apiUrl || !userId) return;
  const tokens = [];
  try {
    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      const web = await requestFCMToken();
      if (web) tokens.push(web);
    }
  } catch {
    /* ignore */
  }
  const native = window.BeentaraAndroid?.getNativeFcmToken?.();
  if (native && String(native).length >= 32) tokens.push(native);
  await Promise.all(
    tokens.map((deviceToken) =>
      fetch(`${apiUrl}/firebase/unregister-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
        },
        body: JSON.stringify({ user_id: String(userId), deviceToken }),
      }).catch(() => null)
    )
  );
}
